// extracted by mini-css-extract-plugin
export default {"loadCategories":"LoadCategories_loadCategories__PNe+W"};